<template>
    <div class="col-lg-10 col-md-8 col-12 main">
        <Swiper :list="list" />
    </div>
</template>
<script>
import Swiper from "@/components/Swiper.vue";
export default {
    name: "home",
    components: {
        Swiper
    },
    data() {
        return {
            list: [
                { img: require("@/assets/resource/community_forum_activities/tutor_materials/1.png"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/tutor_materials/2.png"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/tutor_materials/3.png"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/tutor_materials/4.png"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/tutor_materials/5.png"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/tutor_materials/6.png"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/tutor_materials/7.png"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/tutor_materials/8.png"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/tutor_materials/9.png"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/tutor_materials/10.png"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/tutor_materials/11.png"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/tutor_materials/12.png"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/tutor_materials/13.png"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/tutor_materials/14.png"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/tutor_materials/15.png"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/tutor_materials/16.png"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/tutor_materials/17.png"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/tutor_materials/18.png"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/tutor_materials/19.png"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/tutor_materials/20.png"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/tutor_materials/21.png"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/tutor_materials/22.png"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/tutor_materials/23.png"), alt: "123" },
                { img: require("@/assets/resource/community_forum_activities/tutor_materials/24.png"), alt: "123" }
            ]
        }
    },

};
</script>
<style scoped>
/* 
*{border:1px solid #000;} */

.main {
    height: 100vh;
    padding: 30px 15px;
}

@media (max-width: 768px) {
    .main {
        padding-top: 0px;
        height: calc(100vh - 90px);
    }

}
</style>